/* istanbul ignore file */

const asapLogoMobile = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={96}
    height={32}
    viewBox="0 0 96 32"
    fill="none"
  >
    <g clipPath="url(#clip0_23048_20010)">
      <path
        d="M15.2989 19.4295L12.3394 22.2632C11.1863 22.5948 9.99777 22.7873 8.79902 22.8366C4.01197 22.8366 2.46191 19.607 2.46191 16.6845C2.46191 15.3601 2.77267 13.0553 4.76295 11.816C5.7359 11.2426 8.01105 10.0921 15.2989 9.73697V8.05373C15.2989 5.61951 14.3667 4.91292 11.6661 4.91292C9.45183 4.96815 7.25274 5.29491 5.1181 5.88587L4.14515 2.4787C7.05051 0.949192 10.2771 0.130192 13.5602 0.0888728C18.6062 0.0888728 21.525 2.03477 21.525 7.30275V17.9238H24.9359V21.1127C23.1334 22.1511 21.0968 22.715 19.0168 22.7515C17.4668 22.7515 15.7391 22.5296 15.4284 19.4221L15.2989 19.4295ZM15.2989 17.0396V12.6003C9.40943 13.2181 9.05798 15.0789 9.05798 16.0963C9.05798 17.576 9.76457 18.5305 11.359 18.5305C12.7927 18.4425 14.1661 17.9227 15.2989 17.0396Z"
        fill="url(#paint0_linear_23048_20010)"
      />
      <path
        d="M43.4885 1.7722C43.4885 3.76249 43.4441 5.66399 43.4441 7.65798L41.2725 7.92434C40.7879 6.81451 40.2552 5.75277 39.7705 4.69104C38.7774 4.15162 37.6674 3.86332 36.5373 3.85127C34.6358 3.85127 33.8367 4.69104 33.8367 5.79717C33.8367 6.90329 34.8133 7.56919 37.9985 8.85289C42.6006 10.6656 44.861 12.3488 44.861 16.0668C44.861 19.8735 42.2048 22.8811 34.8725 22.8811C31.8168 22.8811 28.7648 22.2189 27.2147 21.2866L26.8448 14.8719L28.9682 14.4723L30.5775 18.0127C31.6392 18.7525 33.2781 19.1225 34.5174 19.1225C36.3671 19.1225 38.2168 18.3271 38.2168 16.8214C38.2168 15.0531 36.4892 14.3872 34.2769 13.4143C31.051 12.0381 27.248 10.6656 27.248 6.65913C27.248 2.78954 29.9893 0.177746 36.1266 0.177746C38.7162 0.177746 41.4057 0.706763 43.4885 1.7722Z"
        fill="url(#paint1_linear_23048_20010)"
      />
      <path
        d="M59.9472 19.4295L56.9877 22.2632C55.8346 22.5948 54.6461 22.7873 53.4473 22.8366C48.6677 22.8366 47.1176 19.607 47.1176 16.6845C47.1176 15.3601 47.4284 13.0553 49.4187 11.816C50.3916 11.2426 52.6483 10.0921 59.9509 9.73697V8.05373C59.9509 5.61951 59.0224 4.91292 56.3218 4.91292C54.1075 4.96815 51.9084 5.29491 49.7738 5.88587L48.7935 2.4787C51.7035 0.947454 54.9352 0.128419 58.2233 0.0888728C63.2693 0.0888728 66.1881 2.03477 66.1881 7.30275V17.9238H69.599V21.1127C67.7965 22.1511 65.7599 22.715 63.6799 22.7515C62.1336 22.7515 60.4059 22.5296 60.0952 19.4221L59.9472 19.4295ZM59.9472 17.0396V12.6003C54.0614 13.2181 53.71 15.0789 53.71 16.0963C53.71 17.576 54.4166 18.5305 56.011 18.5305C57.4435 18.4424 58.8158 17.9226 59.9472 17.0396Z"
        fill="url(#paint2_linear_23048_20010)"
      />
      <path
        d="M72.2478 21.3608V28.4599L84.7 14.354L72.2478 21.3608Z"
        fill="url(#paint3_linear_23048_20010)"
      />
      <path
        d="M72.2478 15.4747V21.2421L84.6001 12.7926L72.2478 15.4747Z"
        fill="url(#paint4_linear_23048_20010)"
      />
      <path
        d="M73.1319 0.0700867L69.107 0.103382V3.36627L84.0859 8.58986L73.1319 0.0700867Z"
        fill="url(#paint5_linear_23048_20010)"
      />
      <path
        d="M72.2478 4.83526V9.79249L84.2006 10.0995L72.2478 4.83526Z"
        fill="url(#paint6_linear_23048_20010)"
      />
      <path
        d="M72.2478 10.0289V15.271L84.3671 11.4347L72.2478 10.0289Z"
        fill="url(#paint7_linear_23048_20010)"
      />
      <path
        d="M88.9951 11.2165L89.0136 11.2387L89.0099 11.198L88.9951 11.2165Z"
        fill="url(#paint8_linear_23048_20010)"
      />
      <path
        d="M84.996 0C83.798 0.0251862 82.6081 0.204225 81.4557 0.532717L78.4 3.38497L88.8767 10.2622L89.9496 11.0021L89.3687 11.6051L89.2541 11.7198L89.095 11.8825L78.8476 21.9561C80.4059 22.5242 82.0537 22.8074 83.7123 22.7921C90.8374 22.7921 93.538 17.7461 93.538 10.9762C93.538 5.22358 91.3701 0 84.996 0Z"
        fill="url(#paint9_linear_23048_20010)"
      />
      <path
        d="M72.2478 28.5042L69.0626 29.7435L69.2402 32.0001H81.8959L82.0772 29.6103L78.4037 28.5042L78.363 22.4371L72.2478 28.4672V28.5042Z"
        fill="url(#paint10_linear_23048_20010)"
      />
      <path
        d="M72.196 28.5224L72.2478 28.4672L72.2478 28.4599L72.196 28.5224Z"
        fill="url(#paint11_linear_23048_20010)"
      />
      <path
        d="M88.9951 11.2165V11.198V11.2387V11.2165Z"
        fill="url(#paint12_linear_23048_20010)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_23048_20010"
        x1={2.46191}
        y1={31.9026}
        x2={92.9827}
        y2={31.9026}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8C4E9F" />
        <stop offset={0.484375} stopColor="#0C8DC3" />
        <stop offset={1} stopColor="#34A270" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_23048_20010"
        x1="0"
        y1="0"
        x2="0"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.01} stopColor="#8C4F9E" />
        <stop offset={0.51} stopColor="#008DC2" />
        <stop offset={1} stopColor="#41A03F" />
      </linearGradient>
      <clipPath id="clip0_23048_20010">
        <rect width={96} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default asapLogoMobile;
